import $ from 'jquery';
import noUiSlider from 'nouislider/nouislider.min';

/**
 * Runner configs
 */
export const runnerV1Semantics = {
    'filterWrapClass': 'catalog-filtered-grid__filter-block',
    'mainWrapClass': 'runner-v1__wrap',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'minValueInputSelectorModified': 'data-min-value-input-selector',
    'maxValueInputSelectorModified': 'data-max-value-input-selector',
    'minValueModified': 'data-min-value',
    'maxValueModified': 'data-max-value',
    'currentMinValueModified': 'data-current-min-value',
    'currentMaxValueModified': 'data-current-max-value',
    'stepModified': 'data-step',
    'sliderHandleClass': 'runner-v1__handle',
    'sliderRangeClass': 'runner-v1__range',
    'isCloneAttribute': 'data-is-clone',
};

/**
 * Runner initializer
 */
$(function() {

    if ($(`.${runnerV1Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    window.widgets.runnerV1 = new RunnerV1();
    window.widgets.runnerV1.init();
});

class RunnerV1
{
    init() {
        /**
         * Checking other instances
         */
        $(`.${runnerV1Semantics.mainWrapClass}`).each((index, el) => {
            let isInitialized =
                ($(el).attr(`${runnerV1Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.runnerV1.registerInstance($(el));
            }
        });
    }

    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.instances = {};
    }

    /**
     * Checker and normalize if needed minCurrent/maxCurrent values
     * @param float minBound
     * @param float maxBound
     * @param float minCurrent
     * @param float maxCurrent
     * @return {minCurrent: float, maxCurrent: float}
     */
    normalizeValues(
        minBound, maxBound,
        minCurrent, maxCurrent
    ) {
        let values = {
            minCurrent: minCurrent,
            maxCurrent: maxCurrent
        };
        // bound checkers

        // on min bound
        if (values.minCurrent < minBound) {
            values.minCurrent = minBound;
        }
        if (values.maxCurrent < minBound) {
            values.maxCurrent = minBound;
        }

        // on max bound
        if (values.minCurrent > maxBound) {
            values.minCurrent = maxBound;
        }
        if (values.maxCurrent > maxBound) {
            values.maxCurrent = maxBound;
        }

        return values;
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el, isClone) {
        let self = this;
        let instanceId = 
            el.attr(`${runnerV1Semantics.instanceIdAttribute}`) || false;
        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance runner with id [${instanceId}]`);
        }

        let instance = {};
        instance.filterWrap = el.parents(`.${runnerV1Semantics.filterWrapClass}`);
        if (!instance.filterWrap.length) {
            throw new Error(`Invalid semantic for widget` +
                `runner with instance id [${instanceId}]`);
        }
        instance.minInput = instance.filterWrap.find(
            el.attr(`${runnerV1Semantics.minValueInputSelectorModified}`)
        );
        instance.maxInput = instance.filterWrap.find(
            el.attr(`${runnerV1Semantics.maxValueInputSelectorModified}`)
        );
        if (!instance.minInput.length || !instance.maxInput.length) {
            throw new Error(`Invalid semantic for widget` +
                `runner with instance id [${instanceId}]`);
        }

        try {
            const minValue = parseFloat(el.attr(
                `${runnerV1Semantics.minValueModified}`
            ));
            const maxValue = parseFloat(el.attr(
                `${runnerV1Semantics.maxValueModified}`
            ));

            let nojQueryEl = el[0];
            let sliderInstance = noUiSlider.create(nojQueryEl, {
                start: [
                    parseFloat(instance.minInput.val()) || minValue, 
                    parseFloat(instance.maxInput.val()) || maxValue
                ],
                connect: true,
                range: {
                    'min': minValue,
                    'max': maxValue
                },
                step: parseFloat(el.attr(
                    `${runnerV1Semantics.stepModified}`
                )),
            });

            // проверяем клон или не клон текущий объект
            let isClone = !!el.attr(`${runnerV1Semantics.isCloneAttribute}`);

            nojQueryEl.noUiSlider.on('end', function(values, handle) {
                let min = values[0];
                let max = values[1];

                // set value's
                // set only min
                if (handle === 0) {
                    if (min % 1 === 0) {
                        instance.minInput.val(parseInt(min));
                        instance.minInput.attr('value', parseInt(min));
                    } else {
                        instance.minInput.val(min);
                        instance.minInput.attr('value', min);
                    }
                }
                // set only max
                if (handle === 1) {
                    if (max % 1 === 0) {
                        instance.maxInput.val(parseInt(max));
                        instance.maxInput.attr('value', parseInt(min));
                    } else {
                        instance.maxInput.val(max);
                        instance.maxInput.attr('value', max);
                    }
                }
                // \set value's

                let vals = self.normalizeValues(
                    minValue, maxValue,
                    instance.minInput.val(), 
                    instance.maxInput.val(),
                );

                // change only min
                if (handle === 0) {

                    // clear value if reset
                    if (minValue == vals.minCurrent) {
                        instance.minInput.val('');
                        instance.minInput.attr('value', '');
                    } else {
                        instance.minInput.val(vals.minCurrent);
                        instance.minInput.attr('value', vals.minCurrent);
                    }
                    // trigger change event
                    instance.minInput.trigger('change');

                }

                // change only max
                if (handle === 1) {

                    // clear value if reset
                    if (maxValue == vals.maxCurrent) {
                        instance.maxInput.val('');
                        instance.maxInput.attr('value', '');
                    } else {
                        instance.maxInput.val(vals.maxCurrent);
                        instance.maxInput.attr('value', vals.maxCurrent);
                    }
                    // trigger change event
                    instance.minInput.trigger('change');
                    
                }

                // если этот виджет клон обновляем значение в оригинальных слайдерах
                if(isClone) {
                    let originalInstanceId = el.attr(runnerV1Semantics.isCloneAttribute);
                    let originalSlider = window.widgets.runnerV1.instances[originalInstanceId];
                    if (originalSlider && originalSlider.plugin) {
                        // Обновляем значения оригинального слайдера
                        originalSlider.plugin.set(values);
                        originalSlider.minInput.val(min).attr('value', min).trigger('change');
                        originalSlider.maxInput.val(max).attr('value', max).trigger('change');
                    }
                }

            });

            instance.minInput.on('blur', function(e) {
                nojQueryEl.noUiSlider.set([
                    instance.minInput.val(),
                    null
                ]);
            });
            instance.maxInput.on('blur', function(e) {
                nojQueryEl.noUiSlider.set([
                    null,
                    instance.maxInput.val()
                ]);
            });

            instance.maxInput.on('focus', function(e) {
                instance.maxInput.val('');
                instance.maxInput.attr('value', '');
                instance.maxInput.attr('data-default', '');
                instance.maxInput.attr('placeholder', '');
            });
            instance.maxInput.on('focusout', function(e) {
                instance.maxInput.trigger('change');
            });

            instance.minInput.on('focus', function(e) {
                instance.minInput.val('');
                instance.minInput.attr('value', '');
                instance.minInput.attr('data-default', '');
                instance.minInput.attr('placeholder', '');
            });
            instance.minInput.on('focusout', function(e) {
                instance.minInput.trigger('change');
            });

            el.attr(`${runnerV1Semantics.isInitializedAttribute}`, true);
            instance.plugin = sliderInstance;
            window.widgets.runnerV1.instances[instanceId] = instance;

        } catch(e) {
            throw e;
        }
    }

    /**
     * Reinit принимает селектор jQuery элемента уже с runnerV1Semantics.mainWrapClass
     * @param el
     * @param addId
     */
    reInit(el,  addId = '') {
        el.empty();
        // чтобы создать клону ссылку на оригинальный экземпляр слайдера
        // чтобы сделать связь между слайдерами
        if(addId.length) {
             el.attr(
                 `${runnerV1Semantics.isCloneAttribute}`,
                 el.attr(`${runnerV1Semantics.instanceIdAttribute}`)
             )
        }
        // добавляет метку к атрибуту если это клон.
        el.attr(
            `${runnerV1Semantics.instanceIdAttribute}`,
            el.attr(`${runnerV1Semantics.instanceIdAttribute}`) + addId
        );

        let isInitialized = el.attr(`${runnerV1Semantics.isInitializedAttribute}`) === 'true';
        if (isInitialized) {
            // Если уже инициализирован, уничтожаем существующий экземпляр слайдера
            let instanceId = el.attr(`${runnerV1Semantics.instanceIdAttribute}`);

            if (window.widgets.runnerV1.instances[instanceId] && window.widgets.runnerV1.instances[instanceId].plugin) {
                // Удаление плагина noUiSlider и снятие обработчиков событий
                window.widgets.runnerV1.instances[instanceId].plugin.destroy();
                delete window.widgets.runnerV1.instances[instanceId];
            }
            el.removeAttr(`${runnerV1Semantics.isInitializedAttribute}`);
        }
        // Регистрируем экземпляр заново
        this.registerInstance(el);
    }
}